export default __webpack_public_path__ + "static/media/Proveedores_Formato_de_facturas_y_notas_de_credito.3e0fbfbc.xlsx";